/**
 * Utility class in order to manage the scroll position on the page.
 */
export class Scroll {
  /**
   * Scroll to the page top.
   */
  static scrollTop() {
    Scroll.scrollTo('body');
  }

  /**
   * Scroll To.
   *
   * @param {string} inputSelector -  - Input selector of a dom element.
   */
  static scrollTo(inputSelector) {
    const element = document.querySelector(inputSelector);

    if (element && typeof element.scrollIntoView === 'function') {
      element.scrollIntoView();
    }
  }
}
